export default {
  SET_CURRENT_USER: (state, userData) => {
    state.currentUser = userData;
  },
};
